"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
/**
 * @internal
 * Copy and paste plugin for handling onCopy and onPaste event
 */
var CopyPastePlugin = /** @class */ (function () {
    /**
     * Construct a new instance of CopyPastePlugin
     * @param options The editor options
     */
    function CopyPastePlugin(options) {
        var _this = this;
        this.onPaste = function (event) {
            var range;
            roosterjs_editor_dom_1.extractClipboardEvent(event, function (clipboardData) { return _this.editor.paste(clipboardData); }, {
                allowLinkPreview: _this.editor.isFeatureEnabled("PasteWithLinkPreview" /* PasteWithLinkPreview */),
                allowedCustomPasteType: _this.state.allowedCustomPasteType,
                getTempDiv: function () {
                    range = _this.editor.getSelectionRange();
                    return _this.getTempDiv();
                },
                removeTempDiv: function (div) {
                    _this.cleanUpAndRestoreSelection(div, range);
                },
            });
        };
        this.state = {
            allowedCustomPasteType: options.allowedCustomPasteType || [],
        };
    }
    /**
     * Get a friendly name of  this plugin
     */
    CopyPastePlugin.prototype.getName = function () {
        return 'CopyPaste';
    };
    /**
     * Initialize this plugin. This should only be called from Editor
     * @param editor Editor instance
     */
    CopyPastePlugin.prototype.initialize = function (editor) {
        var _this = this;
        this.editor = editor;
        this.disposer = this.editor.addDomEventHandler({
            paste: this.onPaste,
            copy: function (e) { return _this.onCutCopy(e, false /*isCut*/); },
            cut: function (e) { return _this.onCutCopy(e, true /*isCut*/); },
        });
    };
    /**
     * Dispose this plugin
     */
    CopyPastePlugin.prototype.dispose = function () {
        this.disposer();
        this.disposer = null;
        this.editor = null;
    };
    /**
     * Get plugin state object
     */
    CopyPastePlugin.prototype.getState = function () {
        return this.state;
    };
    CopyPastePlugin.prototype.onCutCopy = function (event, isCut) {
        var _this = this;
        var originalRange = this.editor.getSelectionRange();
        if (originalRange && !originalRange.collapsed) {
            var html = this.editor.getContent(2 /* RawHTMLWithSelection */);
            var tempDiv_1 = this.getTempDiv(true /*forceInLightMode*/);
            var newRange = roosterjs_editor_dom_1.setHtmlWithSelectionPath(tempDiv_1, html, this.editor.getTrustedHTMLHandler());
            if (newRange) {
                roosterjs_editor_dom_1.addRangeToSelection(newRange);
            }
            this.editor.triggerPluginEvent(9 /* BeforeCutCopy */, {
                clonedRoot: tempDiv_1,
                range: newRange,
                rawEvent: event,
                isCut: isCut,
            });
            this.editor.runAsync(function (editor) {
                _this.cleanUpAndRestoreSelection(tempDiv_1, originalRange);
                if (isCut) {
                    editor.addUndoSnapshot(function () {
                        var position = _this.editor.deleteSelectedContent();
                        editor.focus();
                        editor.select(position);
                    }, "Cut" /* Cut */);
                }
            });
        }
    };
    CopyPastePlugin.prototype.getTempDiv = function (forceInLightMode) {
        var _this = this;
        var div = this.editor.getCustomData('CopyPasteTempDiv', function () {
            var tempDiv = roosterjs_editor_dom_1.createElement(3 /* CopyPasteTempDiv */, _this.editor.getDocument());
            _this.editor.insertNode(tempDiv, {
                position: 4 /* Outside */,
            });
            return tempDiv;
        }, function (tempDiv) { var _a; return (_a = tempDiv.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(tempDiv); });
        if (forceInLightMode) {
            div.style.backgroundColor = 'white';
            div.style.color = 'black';
        }
        div.style.display = '';
        div.focus();
        return div;
    };
    CopyPastePlugin.prototype.cleanUpAndRestoreSelection = function (tempDiv, range) {
        this.editor.select(range);
        tempDiv.style.backgroundColor = '';
        tempDiv.style.color = '';
        tempDiv.style.display = 'none';
        roosterjs_editor_dom_1.moveChildNodes(tempDiv);
    };
    return CopyPastePlugin;
}());
exports.default = CopyPastePlugin;
//# sourceMappingURL=CopyPastePlugin.js.map